import { render, staticRenderFns } from "./BaseShowMore.vue?vue&type=template&id=5aa324f6&scoped=true&lang=pug&"
import script from "./BaseShowMore.vue?vue&type=script&lang=js&"
export * from "./BaseShowMore.vue?vue&type=script&lang=js&"
import style0 from "./BaseShowMore.vue?vue&type=style&index=0&id=5aa324f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa324f6",
  null
  
)

export default component.exports